module.exports = __webpack_public_path__ + "static/media/chill.06505638.svg";